<template>
  <div :class="size == 'sm' ? `info-switch-sm` : `info-switch`">
    <label class="w-100 font-weight-bold">{{ title }} </label>
    <b-checkbox v-model="localValue" switch :disabled="disabled" data-cy="info-switch-chx">
      <slot>
        {{ localValue ? $t("on") : $t("off") }}
      </slot>
    </b-checkbox>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

const props = withDefaults(defineProps<{ value: boolean; size?: "sm" | "lg"; title: string; disabled?: boolean }>(), {
  disabled: false,
  size: "sm"
});

const emits = defineEmits(["input"]);

const localValue = computed({
  get() {
    return props.value;
  },
  set(nv) {
    emits("input", nv);
  }
});
</script>
